import React from 'react';

import { TrendingUp, UserPlus, ShoppingCart } from 'lucide-react';

import AdminLayout from '../../components/layout/AdminLayout';

const Dashboard: React.FC = () => {
  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Dashboard', href: '#' },
  ];

  return (
    <AdminLayout
      activeMenuItem="/admin/dashboard"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Main.Dashboard.View"
    >
      <div className="p-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 ">
          {/* Metrics Cards */}
          <div className="bg-white dark:bg-graphite text-gray-700 dark:text-cream rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-semibold">Total Sales</h2>
              <TrendingUp className="w-6 h-6 text-emerald-500" />
            </div>
            <p className="text-3xl font-bold text-emerald-500 mt-4">$25,340</p>
            <p className="text-sm text-gray-500 dark:text-harbor mt-2">
              Compared to last week: +12%
            </p>
          </div>
          <div className="bg-white dark:bg-graphite text-gray-700 dark:text-cream rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-semibold">New Customers</h2>
              <UserPlus className="w-6 h-6 text-emerald-500" />
            </div>
            <p className="text-3xl font-bold text-emerald-500 mt-4">1,250</p>
            <p className="text-sm text-gray-500 dark:text-harbor mt-2">
              Compared to last week: +8%
            </p>
          </div>
          <div className="bg-white dark:bg-graphite text-gray-700 dark:text-cream rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-semibold">Completed Orders</h2>
              <ShoppingCart className="w-6 h-6 text-emerald-500" />
            </div>
            <p className="text-3xl font-bold text-emerald-500 mt-4">987</p>
            <p className="text-sm text-gray-500 dark:text-harbor mt-2">
              Compared to last week: +5%
            </p>
          </div>
        </div>

        {/* Sales Overview */}
        <div className="bg-white dark:bg-graphite text-gray-700 dark:text-cream rounded-lg shadow p-6 mt-8">
          <h2 className="text-xl font-semibold mb-4">Sales Overview</h2>
          <div className="h-64 bg-gray-100 dark:bg-seam rounded-lg flex items-center justify-center">
            <p className="text-gray-500 dark:text-harbor">
              [Placeholder for Sales Chart]
            </p>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="bg-white dark:bg-graphite text-gray-700 dark:text-cream rounded-lg shadow p-6 mt-8">
          <h2 className="text-xl font-semibold mb-4">Recent Activity</h2>
          <ul className="divide-y divide-gray-200 dark:divide-seam">
            <li className="py-4 flex justify-between items-center">
              <div>
                <p className="font-semibold">Order #12345</p>
                <p className="text-sm text-gray-500 dark:text-harbor">
                  Completed 2 hours ago
                </p>
              </div>
              <span className="text-emerald-500 font-semibold">$250.00</span>
            </li>
            <li className="py-4 flex justify-between items-center">
              <div>
                <p className="font-semibold">New Customer Signup</p>
                <p className="text-sm text-gray-500 dark:text-harbor">
                  3 hours ago
                </p>
              </div>
              <span className="text-gray-500 dark:text-harbor font-semibold">
                +1
              </span>
            </li>
            <li className="py-4 flex justify-between items-center">
              <div>
                <p className="font-semibold">Order #12344</p>
                <p className="text-sm text-gray-500 dark:text-harbor">
                  5 hours ago
                </p>
              </div>
              <span className="text-emerald-500 font-semibold">$180.00</span>
            </li>
          </ul>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Dashboard;
